import { Directive, ElementRef, HostListener, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
    selector: '[comNumbersOnly]'
})
export class OnlyNumberDirective {

    constructor(private elementref: ElementRef, private rederer: Renderer2, @Inject(DOCUMENT) private document: Document) { }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.elementref.nativeElement.value;

        this.elementref.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if (initalValue !== this.elementref.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
